"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CELL_PADDING = void 0;
const style_1 = __importDefault(require("style"));
exports.CELL_PADDING = style_1.default.Layout.Spacing.Increased;
